const pages = [
    "Coal And Mineral Drilling Services Detail",
    "Geotechnical Drilling And Soil Investigation Detail",
    "Surface Mapping Detail",
    "Workshop Detail",
  ];

  export default pages